import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Customer API
export const customerAPI = {
  getAll: () => api.get('/customers'),
  getById: (id) => api.get(`/customers/${id}`),
  create: (data) => api.post('/customers', data),
  update: (id, data) => api.put(`/customers/${id}`, data),
  delete: (id) => api.delete(`/customers/${id}`),
};

// Consignee API
export const consigneeAPI = {
  getAll: () => api.get('/consignees'),
  getById: (id) => api.get(`/consignees/${id}`),
  create: (data) => api.post('/consignees', data),
  update: (id, data) => api.put(`/consignees/${id}`, data),
  delete: (id) => api.delete(`/consignees/${id}`),
};

// Invoice API
export const invoiceAPI = {
  getAll: () => api.get('/invoices'),
  getById: (id) => api.get(`/invoices/${id}`),
  getNextNumber: () => api.get('/invoices/next-number/generate'),
  create: (data) => api.post('/invoices', data),
  update: (id, data) => api.put(`/invoices/${id}`, data),
  delete: (id) => api.delete(`/invoices/${id}`),
  logDownload: (id) => api.post(`/invoices/${id}/download`),
  logPrint: (id) => api.post(`/invoices/${id}/print`),
};

// Audit Log API
export const auditLogAPI = {
  getAll: (params) => api.get('/audit-logs', { params }),
  getStats: (params) => api.get('/audit-logs/stats', { params }),
  getActions: () => api.get('/audit-logs/actions'),
};

// Health check
export const healthCheck = () => api.get('/health');

export default api;
